module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-teal-rubric-65067e92dc54eff7c63726ad1f60c326.svg";